export default __webpack_public_path__ + "static/news3-4fe76f5fb0e7b4b324e9106e48921f3b.jpg";